<template>
  <div class="grid pa-5">
    <!-- <base-search class="full-card" :is-search-header="true" /> -->
    <card-component
      @click="$router.push('/')"
      class="new-order order-0"
      :class="[user?.canSeeAgentsSales ? '' : 'full-card']"
      :title="$t('Header.controlPanel')"
      :subtitle="$t('Header.pendingItems')"
      :value="cartTotal"
      icon="mdi-face-agent"
    />
    <card-component
      @click="
        $router.push(
          `orders/allorders?mainStatus=2&orderDate=${new Date().toISOString()}`
        )
      "
      class="orders"
      :title="$t('Header.myorders')"
      :subtitle="$t('Header.activeorders')"
      :value="openOrders"
      icon="mdi-clipboard-text-clock"
    />
    <card-component
      @click="$router.push('/customers/allcustomers')"
      class="full-card customers"
      :class="[user?.canSeeAgentsSales ? 'order-2' : 'order-1']"
      :title="$t('Header.cunstomers')"
      :subtitle="$t('Header.activeCustomers')"
      :value="activeCustomers"
      icon="mdi-invoice-text-outline"
    />
    <card-component
      @click="$router.push('/tomorrowOrders/tommorowcustomers')"
      class="new-order"
      :title="$t('Header.tommorowOrders')"
      :subtitle="$t('Header.openTommorowOrders')"
      :value="
        getCustomersWithTommorowDistLine +
        '/' +
        getCustomersMadeOrderForTommorowDistLineCount
      "
      icon="mdi-invoice-clock-outline"
    />
    <card-component
      @click="$router.push('/agentRequests')"
      class="full-card new-order"
      :class="[user?.canSeeAgentsSales ? '' : '']"
      :title="$t('CartWidget.title')"
      :subtitle="$t('CartWidget.waitingAgentRequest')"
      :value="openAgentRequests"
      icon="mdi-bell"
    />
    <card-component
      v-if="user?.canSeeAgentsSales"
      @click="$router.push('/AgentSales')"
      class="new-order"
      :class="[user?.canSeeAgentsSales ? 'order-1' : '']"
      :title="$t('Header.agentSales')"
      :subtitle="$t('Header.agentSalesSubTitle')"
      :value="'-'"
      icon="mdi-flag-checkered"
    />
    <card-component
      @click="openCustomerDevelopmentForm"
      class="full-card new-order"
      title="פתיחת לקוח"
      subtitle="טופס פתיחת לקוח"
      :value="'-'"
      icon="mdi-account-plus-outline"
    />
    <card-component
      @click="isCatalogOpen = true"
      class="full-card customers"
      title="קטלוג"
      subtitle="עיון בקטלוג"
      :value="'-'"
      icon="mdi-book-open-variant"
    />

    <!-- Catalog Fullscreen Dialog -->
    <v-dialog
      v-model="isCatalogOpen"
      fullscreen
      :scrim="false"
      transition="dialog-bottom-transition"
    >
      <v-card class="catalog-dialog">
        <v-toolbar density="compact" color="white">
          <v-toolbar-title>קטלוג</v-toolbar-title>
          <v-spacer />
          <v-btn icon="mdi-close" @click="isCatalogOpen = false" />
        </v-toolbar>
        <div class="catalog-iframe-wrapper">
          <iframe
            v-if="isCatalogOpen"
            class="catalog-iframe"
            src="https://heyzine.com/flip-book/07bbde8f91.html"
            allowfullscreen
            allow="fullscreen"
          />
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
// import BaseSearch from "../menus/BaseSearch.vue";
import CardComponent from "../helpers/CardComponent.vue";
import config from "@/config";
import SiteService from "@/services/SiteService";

export default {
  components: {
    // BaseSearch,
    CardComponent,
  },
  data() {
    return {
      isCatalogOpen: false,
    };
  },
  methods: {
    async openCustomerDevelopmentForm() {
      // open before the await so popup blockers allow it
      const win = window.open("", "_blank");
      const { data } = await SiteService.getCustomerDevelopmentUrl().catch(() => ({}));
      win.location = data?.url || config.customerDevelopmentUrl;
    },
  },
  computed: {
    ...mapGetters({
      getCustomersWithTommorowDistLine:
        "Customers/getCustomersWithTommorowDistLine",
      getCustomersMadeOrderForTommorowDistLineCount:
        "Customers/getCustomersMadeOrderForTommorowDistLineCount",
      cartTotal: "Orders/getCartTotal",
      openOrders: "Orders/getOpenOrders",
      activeCustomers: "Customers/getActiveCustomers",
      openAgentRequests: "AgentRequests/getOpenAgentRequests",
      getUserRole: "AuthModule/getUserRole",
      user: "AuthModule/getUser",
    }),
  },
};
</script>

<style lang="scss" scoped>
.grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  justify-content: space-between;
  gap: 20px;
  max-width: 600px;
  margin: auto;
}

@media (max-width: 768px) {
  .v-container {
    max-width: 90%;
  }
}

.full-card {
  grid-column-start: 1;
  grid-column-end: 3;
}
.new-order {
  order: 10;
  background: $controlPanelNavCardColor;
}
.customers {
  order: 10;
  background: $customersNavCardColor;
}
.orders {
  order: 10;
  background: $ordersNavCardColor;
}

.catalog-dialog {
  display: flex;
  flex-direction: column;
  height: 100%;

  .catalog-iframe-wrapper {
    flex: 1 1 auto;
    width: 100%;
    height: 100%;
  }

  .catalog-iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
}
</style>
